import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { forbiddenNameValidator } from '../../../shared/directives/forbidden-name.directive';
import { crossValidator } from '../../../shared/directives/cross-validator';

@Component({
    selector: 'app-dynamicformbuilder',
    templateUrl: './dynamicformbuilder.component.html',
    styleUrls: ['./dynamicformbuilder.component.css'],
    standalone: false
})
export class DynamicformbuilderComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();
  @Input() fields: any[] = [];
  form: FormGroup;
  constructor() { }

  ngOnInit() {
    let fieldsCtrls = {};
    for (let f of this.fields) {
      let fieldValidators = [];
      if (f.required) {
        fieldValidators.push(Validators.required);
      }
      if (f.maxLength) {
        fieldValidators.push(Validators.maxLength(f.maxLength));
      }
      if (f.forbiddenNameValidator) {
        fieldValidators.push(forbiddenNameValidator(/bob/i));
      }
      if (f.type != 'checkbox') {
        fieldsCtrls[f.name] = new FormControl(f.value || '', fieldValidators);
      } else {
        let opts = {};
        for (let opt of f.options) {
          opts[opt.key] = new FormControl(opt.value);
        }
        fieldsCtrls[f.name] = new FormGroup(opts)
      }
    }
    this.form = new FormGroup(fieldsCtrls, { validators: crossValidator });
  }

  send() {

    //onSubmit.emit(this.form.value)

    //for (let entry of ) {
 
   }
}
